import { render } from "./App.vue?vue&type=template&id=000efc7a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=000efc7a&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__